import Table from './GeneralScrollTable.vue';

export default Table;
